import { showErrorMessage } from "../../common/Toaster";
import jwtAxios from "../../services/axiosInstance/ApiConfig";
import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR } from "../types/actions/Common.actions";
import { SET_UPLOAD_URL } from "../types/actions/ProductAction";
import { getHeaders } from "./Auth";

export const onImageUpload = (bodyFormData: any) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_START })
        try {
            const { data } = await jwtAxios.post('/uploads', bodyFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...getHeaders(),
                },
            });
            dispatch({ type: FETCH_SUCCESS })
            dispatch({ type: SET_UPLOAD_URL, payload: data })
        } catch (error: any) {
            dispatch({ type: FETCH_ERROR, error })
            showErrorMessage(error.message);
        }
    }
};
